/** カテゴリ用の内蔵アイコン（仕様書 §5.3）。 */

export const CATEGORY_ICONS: Record<string, string> = {
  book: '📖',
  camera: '📷',
  run: '🏃',
  food: '🍽',
  work: '💼',
  heart: '❤️',
  star: '⭐',
  pin: '📍',
  music: '🎵',
  leaf: '🌿',
  cup: '☕',
  note: '📝',
};

export const ICON_NAMES = Object.keys(CATEGORY_ICONS);

export const CATEGORY_COLORS = [
  '#4A90D9', '#7B68A6', '#2E9E7B', '#D98A3B',
  '#C0562B', '#B8477E', '#3E7A8C', '#6E8B3D',
  '#8C6239', '#5A6B8C', '#A3512B', '#4F4F4F',
];

export function CatIcon({ name, size = 16 }: { name: string; size?: number }) {
  return (
    <span aria-hidden style={{ fontSize: size, lineHeight: 1 }}>
      {CATEGORY_ICONS[name] ?? CATEGORY_ICONS.note}
    </span>
  );
}
